import React from "react";
import { Box, Paper, Step, StepButton, Stepper } from "@mui/material";
import { useTranslation } from "react-i18next";

const SampleShipmentSteps = ({
  activeStep,
  status,
  onConfirm,
  onReceive,
}) => {
  const { t } = useTranslation();
  const confirmed = ["confirmed", "received"].includes(status);
  const steps = [
    {
      label: t("shipmentOrder", "Shipment Order"),
      completed: ["requested", "confirmed", "received"].includes(status),
    },
    {
      label: t("confirmation", "Confirmation"),
      completed: confirmed,
      onClick: onConfirm,
    },
    {
      label: t("reception", "Reception"),
      completed: status === "received",
      onClick: onReceive,
    },
    {
      label: t("bioBanking", "Bio Banking"),
      completed: false,
    },
  ];

  return (
    <Paper
      component="nav"
      aria-label={t("sampleShipmentSteps", "Sample shipment steps")}
      variant="outlined"
      sx={{ borderRadius: 2, px: { xs: 1, sm: 3 }, py: 2.5 }}>
      <Stepper
        nonLinear
        alternativeLabel
        activeStep={activeStep}
        sx={{
          "& .MuiStep-root": { px: { xs: 0.5, sm: 1 } },
          "& .MuiStepButton-root": { m: 0, p: 0, width: "100%", borderRadius: 1 },
          "& .MuiStepLabel-label": { fontSize: { xs: "0.75rem", sm: "0.875rem" } },
          "& .MuiStepLabel-label.Mui-active": { color: "primary.main", fontWeight: 700 },
          "& .MuiStepButton-root.Mui-focusVisible": { outline: "2px solid", outlineColor: "primary.main" },
        }}>
        {steps.map((step, index) => (
          <Step
            key={index}
            completed={step.completed}
            disabled={!step.onClick}
            sx={
              index <= 2
                ? {
                    "& .MuiStepIcon-root.Mui-completed": {
                      color: "success.main",
                    },
                  }
                : undefined
            }>
            <StepButton
              onClick={step.onClick}
              aria-current={activeStep === index ? "step" : undefined}>
              <Box component="span">{step.label}</Box>
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Paper>
  );
};

export default SampleShipmentSteps;
